// extracted by mini-css-extract-plugin
export default {"wrapper":"CustomDateRangePicker_wrapper__Gvp2i","customDay":"CustomDateRangePicker_customDay__+IVy+"};